var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Search"),React.createElement("circle",{"cx":"3.875","cy":"3.875","r":"3.375","stroke":"black","key":1}),React.createElement("path",{"d":"M6.6875 6.6875L9.5 9.5","stroke":"black","strokeLinecap":"round","key":2})]);
}

Search.defaultProps = {"width":"11","height":"11","viewBox":"0 0 11 11","fill":"none"};

module.exports = Search;

Search.default = Search;
